import round from "lodash/round";
import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../../parts/SvgIcon";
import { convertUnit } from "../../../../../utils/converters/convert-units";

const MEASUREMENT_KEYS = [
  "neck",
  "chest",
  "waist",
  "hips",
  "leftArm",
  "rightArm",
  "leftThigh",
  "rightThigh",
  "leftCalf",
  "rightCalf",
  "glutes",
];

function LogBodyMeasurementsCard({ bodyMeasurements, units = "metric" }) {
  const { t } = useTranslation(["athlete-portal", "common"]);
  const data = bodyMeasurements?.bodyMeasurements;
  if (!data) return null;

  const unitAbbr =
    units === "imperial"
      ? t("common:units.inchAbbr")
      : t("common:units.cmAbbr");

  const rows = MEASUREMENT_KEYS.filter((key) => data[key]).map((key) => ({
    key,
    label: t(`calendar.cards.bodyMeasurements.${key}`),
    value:
      units === "imperial"
        ? `${round(convertUnit(data[key], "cm", "in"), 1)} ${unitAbbr}`
        : `${round(data[key], 1)} ${unitAbbr}`,
  }));

  if (rows.length === 0) return null;

  return (
    <div className="log-card log-card--body-measurements">
      <div className="log-card__header">
        <SvgIcon
          src="/img/new-icons/vuesax-linear-ruler.svg"
          useCurrentColor={true}
        />
        {t("calendar.cards.bodyMeasurements.title")}
      </div>
      <div className="log-card__body">
        {rows.map(({ key, label, value }) => (
          <div key={key} className="log-card__stat-row">
            <span className="log-card__stat-label">{label}</span>
            <span className="log-card__stat-value">{value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default LogBodyMeasurementsCard;
